import React from 'react';
import { Box } from '@mui/material';

import { useAppBarHeight } from 'hooks';

import { HEADER_HEIGHT } from 'config';
import { ContentNavbarProps } from './types';

const ContentNavbar = ({ children }: ContentNavbarProps) => {
  const appbarHeight = useAppBarHeight();
  return (
    <Box
      id="ContentNavbar"
      // p={2}
      // pb={``}
      pt={1}
      pl={2}
      pr={2}
      pb={1}
      position="sticky"
      sx={{
        background: 'inherit',
        zIndex: 2,
        width: '100%',
        borderBottom: 'inherit'
        // top: HEADER_HEIGHT
      }}
    >
      {children}
    </Box>
  );
};

export default ContentNavbar;
